if (!customElements.get('product-add-ons')) {
  customElements.define(
    'product-add-ons',
    class ProductAddOns extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('.product-add-ons__item'));
        this.addOnQuantityInputs = Array.from(this.querySelectorAll('[data-add-on-qty]'));
        this.totalElement = this.querySelector('[data-product-add-ons-total]');
        this.totalRow = this.querySelector('[data-product-add-ons-total-row]');
        this.basePrice = Number(this.dataset.basePrice || 0);
        this.currencyCode = this.dataset.currencyCode || 'AUD';
        this.parentTitle = this.dataset.parentTitle || '';
        this.quantityInput = document.getElementById(`Quantity-${this.dataset.sectionId}`);
        this.productForm = document.getElementById(this.dataset.productFormId);

        this.boundUpdate = this.update.bind(this);
        this.boundAddOnQuantityChange = this.onAddOnQuantityChange.bind(this);
        this.addOnQuantityInputs.forEach((input) => input.addEventListener('change', this.boundAddOnQuantityChange));
        this.quantityInput?.addEventListener('change', this.boundUpdate);
        this.quantityInput?.addEventListener('input', this.boundUpdate);
        this.productForm?.closest('product-form')?.classList.add('product-form--has-add-ons');

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.dataset.sectionId) return;
            if (!event.data.variant) return;

            this.basePrice = Number(event.data.variant.price || 0);
            this.update();
          });
        }

        this.update();
      }

      disconnectedCallback() {
        this.addOnQuantityInputs.forEach((input) => input.removeEventListener('change', this.boundAddOnQuantityChange));
        this.quantityInput?.removeEventListener('change', this.boundUpdate);
        this.quantityInput?.removeEventListener('input', this.boundUpdate);
        this.variantChangeUnsubscriber?.();
      }

      getSelectedAddOns() {
        return this.rows
          .map((row) => {
            const quantityInput = row.querySelector('[data-add-on-qty]');
            const quantity = this.getAddOnQuantity(row);

            if (quantityInput?.disabled || quantity < 1) return null;

            const quantityMode = row.dataset.quantityMode || 'match_parent';

            return {
              variantId: Number(row.dataset.addOnVariantId),
              title: row.dataset.addOnTitle || '',
              type: row.dataset.addOnType || 'extra',
              quantityMode,
              quantity,
              price: Number(row.dataset.addOnPrice || 0),
              parentTitle: this.parentTitle,
            };
          })
          .filter((addOn) => addOn?.variantId && addOn.quantity > 0);
      }

      getAddOnQuantity(row) {
        const input = row.querySelector('[data-add-on-qty]');
        const value = Number(input?.value || 0);
        return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
      }

      onAddOnQuantityChange(event) {
        const value = Number(event.currentTarget.value || 0);

        event.currentTarget.value = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;

        this.update();
      }

      getParentQuantity() {
        const value = Number(this.quantityInput?.value || 1);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      update() {
        const parentQuantity = this.getParentQuantity();

        this.rows.forEach((row) => {
          const quantityInput = row.querySelector('[data-add-on-qty]');
          const isSelected = !quantityInput?.disabled && this.getAddOnQuantity(row) >= 1;
          row.classList.toggle('is-selected', isSelected);
        });

        const selectedAddOns = this.getSelectedAddOns();
        const addOnTotal = selectedAddOns.reduce((total, addOn) => {
          return total + addOn.price * addOn.quantity;
        }, 0);
        const total = this.basePrice * parentQuantity + addOnTotal;

        if (this.totalRow) {
          this.totalRow.hidden = selectedAddOns.length === 0;
        }

        if (this.totalElement) {
          this.totalElement.textContent = this.formatMoney(total);
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currencyCode,
          }).format(cents / 100);
        } catch (error) {
          return `${this.currencyCode} ${(cents / 100).toFixed(2)}`;
        }
      }
    }
  );
}
